import * as turf from "@turf/turf";

import type { DriverRow, DriverSortKey, LocationFilter } from "@/types/driver";

export function applySortFromVolatile(
  roster: DriverRow[],
  volatileMap: Map<string, { unread: boolean | null; latestItemCreatedAt: string | null }>,
  sort: DriverSortKey,
): DriverRow[] {
  if (sort === "alphaAsc" || sort === "alphaDesc") return roster;

  return [...roster].sort((a, b) => {
    const sortKeyA = a.feedId ?? a.workspaceMembershipId;
    const sortKeyB = b.feedId ?? b.workspaceMembershipId;
    const av = volatileMap.get(sortKeyA);
    const bv = volatileMap.get(sortKeyB);

    if (sort === "unread") {
      const aUnread = av?.unread ? 1 : 0;
      const bUnread = bv?.unread ? 1 : 0;
      if (bUnread !== aUnread) return bUnread - aUnread;
      if (aUnread === 1) {
        const aTime = av?.latestItemCreatedAt ?? "";
        const bTime = bv?.latestItemCreatedAt ?? "";
        if (bTime !== aTime) return bTime > aTime ? 1 : -1;
        return 0;
      }
      return 0;
    }

    const aTime = av?.latestItemCreatedAt ?? "";
    const bTime = bv?.latestItemCreatedAt ?? "";
    if (bTime !== aTime) return bTime > aTime ? 1 : -1;
    return 0;
  });
}

export function applyLocationFilter(drivers: DriverRow[], location: LocationFilter): DriverRow[] {
  const units: turf.Units = location.unit === "km" ? "kilometers" : "miles";
  const circle = turf.circle([location.longitude, location.latitude], location.radius, { steps: 32, units });
  return drivers.filter((d) => {
    if (d.latitude == null || d.longitude == null) return false;
    return turf.booleanPointInPolygon(turf.point([d.longitude, d.latitude]), circle);
  });
}
